import BlackList from "../../views/blackList/Index.vue";

const BlackListRoute = [
  {
    path: "/black-list",
    name: "BlackList",
    component: BlackList,
  },
];

export default BlackListRoute;
